import { FAQ_CONTENT } from './faq'
import { CTA_CONTENT } from './cta'
import { LOGO_GARDEN_CONTENT } from './logoGarden'
import { FORM_SETTINGS } from '../elements/formSettings'
import { FORM_POPUP } from './formPopup'

export const INDUSTRY_BLUEPRINT = `
...on industryBlueprint_Entry {
  id
  typeHandle

  labelSt1
  headingSt1 {
    html
  }
  imageMobileSt1 {
    url
  }
  imageDesktopSt1 {
    url
  }
  ${ LOGO_GARDEN_CONTENT }

  pageContent

  case_data_product_discovery
  case_data_cart_recovery
  case_data_product_locator
  case_data_sales_copilot
  case_data_returns_and_exchanges
  case_data_post_purchase_tracking
  case_data_loyalty_qa

  contentSt3

  contentSt4

  contentSt5
  faqHeading
  ${ FAQ_CONTENT }

  contentSt6

  ${ FORM_SETTINGS }
  ${ FORM_POPUP }

  ${ CTA_CONTENT }
}
`
